import initialState from './initialState'
import {FETCH_RELIGIONS, RECEIVE_RELIGIONS} from '../actions/actionTypes'

export default function religions(state = initialState.religions, action) {
	let newState
	switch (action.type) {
	case FETCH_RELIGIONS:
		return {
			...action,
			isFetching: true
		}
	case RECEIVE_RELIGIONS:
		newState = action.religions
		return {
			...newState,
			isFetching: false
		}
	default:
		return state
	}
}


// WEBPACK FOOTER //
// ./src/redux/reducers/religions.js